import React from "react"
import styled from 'styled-components'
import { dark, highlight } from "./styles"
import Img from 'gatsby-image'
import {ProtoCard} from "./card"

type Props = {
  title?: string,
  image?: any,
  width?: string,
  height?: string,
  dark?: boolean,
  footer?: string,
  text?: string,
  color?: string,
  summary: string,
  keywords?: string,
}

const CardTitle = styled.div`
  color: ${highlight};
  align-self: center;
  font-size: 1.5rem;
  justify-self: start;
`

const CardText = styled.div`
  width: 90%;
  height: 100%;
  justify-self: start;
  align-self: center;
  overflow: hidden;
  text-overflow: ellipsis;
`
const CardFooter = styled.div`
  grid-column-start: 2;
  grid-row-start: 3;
  text-align: center;
  padding-top: 10px;
  width: 100%;
  border-top: 1px solid ${dark};
`

const PostCard = styled(ProtoCard)`
  grid-template-rows: 5% 80% 15%;
  grid-template-columns: 5% 90% 5%;
`

const PostTitle = styled(CardTitle)`
  grid-row-start: 1;
`
const ContentArea = styled.div`
  display: grid;
  grid-column-start: 2;
  grid-row-start: 2;
  grid-template-columns: 70% 30%;
  @media (max-width: 560px){
    grid-template-columns: 100%;
    grid-template-rows: 40% 60%;
  }
`
const CardTextContainer = styled.div`
  display: grid;
  grid-column-start: 1;
  grid-template-rows: 20% 60% 20%;
  @media (max-width: 560px){
     grid-row-start: 2;
  }
`
const ImageContainer = styled.div`
  grid-column-start: 2;
  display: grid;
  width: 100%;
  height: 95%;
  @media (max-width: 560px){
     grid-column-start: 1;
     grid-row-start: 1;
     height: 100%;
  }
  overflow: hidden;
  align-self: center;
  justify-self: center;
`
const ArticleCard: React.FC<Props>= ({title, footer, summary, image, keywords}) => {
  return <PostCard>
    <ContentArea>
      <CardTextContainer>
        <PostTitle>{title}</PostTitle>
        <CardText>{summary}</CardText>
        <CardText>{keywords}</CardText>
      </CardTextContainer>
      <ImageContainer><Img fluid={image} style={{borderRadius: 20}}/></ImageContainer>
    </ContentArea>
    <CardFooter>{footer}</CardFooter>
  </PostCard>

}



export default ArticleCard
